const API = {
  GET_FETCH_MEDIA: {
    path: '/expert-content/sort-search',
    method: 'GET',
  },

};
export default API;
